/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Withdiscountsitemtitle3Inputs */

const id_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dengan Diskon`)
};

const ms_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dengan Diskaun`)
};

const da_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Med Rabat`)
};

const de_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Rabatten`)
};

const en_us2_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With Discounts`)
};

const es_es2_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con descuentos`)
};

const es_mx2_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con descuentos`)
};

const fil_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May Diskwento`)
};

const fr_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En promo`)
};

const it_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con Sconti`)
};

const hu_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedvezményekkel`)
};

const nl_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met Korting`)
};

const no_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Med rabatter`)
};

const pl_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z przecenami`)
};

const pt_br2_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com descontos`)
};

const pt_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com descontos`)
};

const ro_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cu reduceri`)
};

const fi_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alemuksilla`)
};

const sv_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Med rabatt`)
};

const vi_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang giảm giá`)
};

const tr_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İndirimli Olanlar`)
};

const cs_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se slevou`)
};

const bg_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С отстъпки`)
};

const ru_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Со скидкой`)
};

const uk_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зі знижками`)
};

const ar_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مع خصومات`)
};

const hi_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छूट के साथ`)
};

const th_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีส่วนลด`)
};

const ja_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割引あり`)
};

const zh_cn2_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打折游戏`)
};

const zh_hant1_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打折遊戲`)
};

const ko_nav_withdiscountsitemtitle3 = /** @type {(inputs: Nav_Withdiscountsitemtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`할인 중`)
};

/**
* | output |
* | --- |
* | "With Discounts" |
*
* @param {Nav_Withdiscountsitemtitle3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_withdiscountsitemtitle3 = /** @type {((inputs?: Nav_Withdiscountsitemtitle3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Withdiscountsitemtitle3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_withdiscountsitemtitle3(inputs)
	if (locale === "ms") return ms_nav_withdiscountsitemtitle3(inputs)
	if (locale === "da") return da_nav_withdiscountsitemtitle3(inputs)
	if (locale === "de") return de_nav_withdiscountsitemtitle3(inputs)
	if (locale === "en-US") return en_us2_nav_withdiscountsitemtitle3(inputs)
	if (locale === "es-ES") return es_es2_nav_withdiscountsitemtitle3(inputs)
	if (locale === "es-MX") return es_mx2_nav_withdiscountsitemtitle3(inputs)
	if (locale === "fil") return fil_nav_withdiscountsitemtitle3(inputs)
	if (locale === "fr") return fr_nav_withdiscountsitemtitle3(inputs)
	if (locale === "it") return it_nav_withdiscountsitemtitle3(inputs)
	if (locale === "hu") return hu_nav_withdiscountsitemtitle3(inputs)
	if (locale === "nl") return nl_nav_withdiscountsitemtitle3(inputs)
	if (locale === "no") return no_nav_withdiscountsitemtitle3(inputs)
	if (locale === "pl") return pl_nav_withdiscountsitemtitle3(inputs)
	if (locale === "pt-BR") return pt_br2_nav_withdiscountsitemtitle3(inputs)
	if (locale === "pt") return pt_nav_withdiscountsitemtitle3(inputs)
	if (locale === "ro") return ro_nav_withdiscountsitemtitle3(inputs)
	if (locale === "fi") return fi_nav_withdiscountsitemtitle3(inputs)
	if (locale === "sv") return sv_nav_withdiscountsitemtitle3(inputs)
	if (locale === "vi") return vi_nav_withdiscountsitemtitle3(inputs)
	if (locale === "tr") return tr_nav_withdiscountsitemtitle3(inputs)
	if (locale === "cs") return cs_nav_withdiscountsitemtitle3(inputs)
	if (locale === "bg") return bg_nav_withdiscountsitemtitle3(inputs)
	if (locale === "ru") return ru_nav_withdiscountsitemtitle3(inputs)
	if (locale === "uk") return uk_nav_withdiscountsitemtitle3(inputs)
	if (locale === "ar") return ar_nav_withdiscountsitemtitle3(inputs)
	if (locale === "hi") return hi_nav_withdiscountsitemtitle3(inputs)
	if (locale === "th") return th_nav_withdiscountsitemtitle3(inputs)
	if (locale === "ja") return ja_nav_withdiscountsitemtitle3(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_withdiscountsitemtitle3(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_withdiscountsitemtitle3(inputs)
	return ko_nav_withdiscountsitemtitle3(inputs)
});
export { nav_withdiscountsitemtitle3 as "nav.withDiscountsItemTitle" }